import React, { useEffect, useRef } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const ArticleView = ({ article, chapter, onInternalLink }) => {
  const scrollRef = useRef(null)

  // Scroll the article's scrollable ancestor (`.hc-main`) back to the top
  // whenever the displayed article changes.
  useEffect(() => {
    const el = scrollRef.current
    if (!el) return
    let parent = el.parentElement
    while (parent) {
      const overflowY = window.getComputedStyle(parent).overflowY
      if (overflowY === 'auto' || overflowY === 'scroll') {
        parent.scrollTop = 0
        break
      }
      parent = parent.parentElement
    }
  }, [article && article.slug])

  if (!article) {
    return (
      <section className="hc-article hc-article--empty" ref={scrollRef}>
        <p className="hc-article__placeholder">{I18n.t('help_center_modal.select_article')}</p>
      </section>
    )
  }

  const components = {
    a: ({ node, href, children, ...props }) => {
      // Internal help links use the `help:` scheme: e.g. [voir](help:interventions/creer-une-intervention)
      if (href && href.startsWith('help:')) {
        const slug = href.slice(5)
        return (
          <a
            href={`#help/${slug}`}
            onClick={e => {
              e.preventDefault()
              onInternalLink(slug)
            }}
          >
            {children}
          </a>
        )
      }
      const isExternal = href && /^https?:\/\//.test(href)
      return (
        <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} {...props}>
          {children}
        </a>
      )
    }
  }

  return (
    <section className="hc-article" ref={scrollRef}>
      <header className="hc-article__header">
        {chapter && <p className="hc-article__breadcrumb">{chapter.title}</p>}
        <h1 className="hc-article__title">{article.title}</h1>
        {article.intro && <p className="hc-article__intro">{article.intro}</p>}
      </header>

      <div className="hc-article__body">
        <ReactMarkdown
          components={components}
          remarkPlugins={[remarkGfm]}
          urlTransform={url => url}
        >
          {article.body}
        </ReactMarkdown>
      </div>
    </section>
  )
}

export default ArticleView
